import router from './router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Route } from 'vue-router'
import { AppModule } from './store/modules/app'
import { UserModule } from '@/store/modules/user'
import i18n from '@/lang'
import settings from './settings'
import { PermissionModule } from "@/store/modules/permission";

NProgress.configure({ showSpinner: false })

const whiteList = []

const getPageTitle = (key: string) => {
  const hasKey = i18n.te(`route.${key}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${pageName} - ${settings.title}`
  }
  return `${settings.title}`
}

router.beforeEach(async (to: Route, _: Route, next: any) => {
  // 启动进度条
  NProgress.start()
  // 关闭侧边栏
  AppModule.CloseSideBar(false)
  next()
  if (to.path === '/') {
    next()
    NProgress.done()
  } else {
     next()
    // try {
    //   // 健康检查
    //   await UserModule.HealthCheck(to)
    //   // 根据角色生成路由列表
    //   PermissionModule.GenerateRoutes([])
    //   // 动态添加路由列表
    //   PermissionModule.dynamicRoutes.forEach((route) => {
    //     router.addRoute(route)
    //   })
    //   // Hack: ensure addRoutes is complete
    //   // Set the replace: true, so the navigation will not leave a history record
    //   next({ ...to, replace: true })
    // } catch (err) {
    //   next({ path: '/' })
    //   NProgress.done()
    // }
  }
})

router.afterEach((to: Route) => {
  // Finish progress bar
  // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
  NProgress.done()

  // set page title
  document.title = getPageTitle(to.meta.title)
})
